import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import ListaEspecialidades from "./ListaEspecialidades";

import { format, addDays, isValid, parse } from "date-fns";

import {
    allowOnlyNumbers,
    formatPhoneNumber,
    getAgencias,
    getStatusStudentList,
    getEstudiantePorTelefono,
    getInterest,
} from "../utils/utils";



const Intereses = ({ parentCallback, disabled }) => {
    let { id } = useParams();
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm();

    const [intereses, setIntereses] = useState([]);
    const [idEspecialidad, setIdEspecialidad] = useState("");
    const [nombreEspecialidad, setNombreEspecialidad] = useState("");
    const [fechaLlamada, setFechaLlamada] = useState("");
    const [fechaAgenda, setFechaAgenda] = useState("");
    const [idEspecialidadReagendar, setIdEspecialidadReagendar] = useState("");
    const [precio, setPrecio] = useState("");
    const [specialityToEnroll, setSpecialityToEnroll] = useState("");
    const [specialityToEdit, setSpecialityToEdit] = useState("");
    const [agencies, setAgencies] = useState([]);
    const [statusStudentList, setStatusStudentList] = useState([]);
    const [idStatusStudent, setIdStatusStudent] = useState([]);
    const [nombreStatusStudent, setNombreStatusStudent] = useState([]);

    let especialidadesCallback = (idEspecialidad, nombreEspecialidad) => {
        setIdEspecialidad(idEspecialidad);
        setNombreEspecialidad(nombreEspecialidad);
    };

    
    useEffect(() => {
        getAgencias().then((agencies) => {
            setAgencies(agencies);
        });
        if (id) {
            getInterest(id).then((interests) => {
                setIntereses(interests);
            }); 
        }
        getStatusStudentList().then((statusStudentList) => {
            setStatusStudentList(statusStudentList);
        });
    }, []);

    useEffect(() => {
        if (!disabled) {   
            //document.getElementById("studentStatus").value = 1;
            //document.getElementById("studentStatus").options[document.getElementById("callstatusEdited").selectedIndex].text = '';
            setIdStatusStudent("");
            setNombreStatusStudent("");
            document.getElementById("precio").value = "";
            setPrecio("");
            parentCallback(intereses);
        }
    }, [intereses]);

    return (
        <div>
            <div className="card my-5">
                <div className="card-header">
                    <strong>Intereses: </strong>
                </div>
                <div className="card-body">
                    <table className="table table-sm table-hover">
                        <thead>
                            <tr>
                                <th style={{ width: 0 + "%" }}>#</th>
                                <th className="col-2">Especialidad</th>
                                <th className="col-2">Estatus</th>
                                <th className="col-2">Agencia</th>
                                <th className="col-1">Próxima llamada</th>
                                <th className="col-1">Fecha agenda</th>
                                <th style={{ width: 3 + "%" }}>Precio</th>
                                <th style={{ width: 0 + "%" }}></th>
                            </tr>
                        </thead>
                        <tbody>
                            {intereses.length > 0
                                ? intereses.map(
                                    (interes) =>
                                        interes.interest_status !== 3 && (
                                            <tr>
                                                <th scope="row">{interes.esp_id}</th>
                                                <td>{interes.esp_nombre}</td>
                                                <td className="text-primary">{interes.name}</td>
                                                <td>{interes.age_nombre}</td>
                                                <td>{interes.fecha_llamada? interes.fecha_llamada.substring(0, 10): ""}</td>
                                                <td>{interes.fecha_agenda? interes.fecha_agenda.substring(0, 10): ""}</td>
                                                <td>{interes.precio}$</td>
                                                <td className="text-end">
                                                    {!disabled && (
                                                        <div className="btn-group">
                                                            <button type="button" className="btn btn-sm btn-dark dropdown-toggle dropdown-toggle-split btn-sm-rows" data-bs-toggle="dropdown" aria-expanded="false">
                                                                <span className="">Acciones </span>
                                                            </button>
                                                            <ul className="dropdown-menu">
                                                                <li>
                                                                    <a className="dropdown-item hand-pointer" data-bs-toggle="modal" data-bs-target="#addOrEditInterestModal" 
                                                                        onClick={() => { console.log(interes); setSpecialityToEdit(interes);}} >
                                                                        <i className="bi bi-card-checklist"></i>{" "}
                                                                        Editar
                                                                    </a>
                                                                    {/* <a className="dropdown-item hand-pointer" 
                                                                        onClick={() => { 
                                                                            if (window.confirm("¿Está seguro de eliminar el interes?"))
                                                                            {
                                                                                interes.interest_status = 3;
                                                                            }
                                                                            setSpecialityToEnroll(interes);
                                                                        }}>
                                                                        <i className="bi bi-trash"></i> Eliminar
                                                                    </a> */}

                                                                    <a className="dropdown-item hand-pointer" data-bs-toggle="modal" data-bs-target="#staticBackdrop"
                                                                        onClick={() => { setIdEspecialidadReagendar(interes.idEspecialidad);}} >
                                                                        <i className="bi bi-arrow-clockwise"></i>{" "}
                                                                        Reagendar
                                                                    </a>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    )}
                                                </td>
                                            </tr>
                                        )
                                )
                                : ""}
                        </tbody>
                    </table>
                    {!disabled && (
                        <div className="card mt-5">
                            <span className="card-header">Nuevo Interes</span>
                            <div className="card-body">
                                <div className="row py-2 align-items-end">
                                    <div className="col-3">
                                        <ListaEspecialidades parentCallback={especialidadesCallback} />
                                    </div>
                                    <div className="form-group col-md-2">
                                        <label htmlFor="studentState">Estatus</label>
                                        <div className="form-group">
                                            {statusStudentList.length > 0 ? (
                                                <select {...register("studentStatus")} disabled={disabled} id="studentStatus" className="form-select" 
                                                    onChange={(e) => {
                                                        setNombreStatusStudent(e.target.options[e.target.selectedIndex].text);
                                                        setIdStatusStudent(e.target.value);
                                                      }}>
                                                    <option key='0' value='0' ></option>
                                                    {statusStudentList.map((statusStudent, index) => (
                                                        <option key={statusStudent.id} value={statusStudent.id} >
                                                            {statusStudent.name}
                                                        </option>
                                                    ))}
                                                </select>
                                            ) : (
                                                <select className="form-select">
                                                    <option>No disponible</option>
                                                </select>
                                            )}
                                        </div>
                                    </div>
                                    <div className="form-group col-2">
                                        <label htmlFor="fechaLlamada">Próxima Llamada</label>
                                        <input type="date" className="form-control" id="fechaLlamada"
                                            onChange={(e) => { setFechaLlamada(e.target.value); }}/>
                                    </div>
                                    <div className="form-group col-2">
                                        <label htmlFor="fechaAgenda">Agendado</label>
                                        <input type="date" className="form-control" id="fechaAgenda"
                                            onChange={(e) => { setFechaAgenda(e.target.value); }}/>
                                    </div>
                                    <div className="form-group col-1">
                                        <label htmlFor="precio">Precio($)</label>
                                        <input onInput={(e) => allowOnlyNumbers(e)} type="text" className="form-control" id="precio" placeholder="Precio"
                                            onChange={(e) => { setPrecio(e.target.value); }} />
                                    </div>
                                    <div className="col-2">
                                        <button type="button" className="btn btn-success col-12"
                                            onClick={() => {
                                                let dateTemp = new Date(fechaLlamada);
                                                let dateTemp2 = new Date(fechaAgenda);

                                                if (idEspecialidad === '83'){ 
                                                    alert('Debe seleccinar una especialidad valida');

                                                }else if (idStatusStudent === '' || idStatusStudent === '0'){ 
                                                    alert('Ingrese el estatus del curso');

                                                }else if (dateTemp === "Invalid Date") {
                                                    alert("Fecha de llamada incorrecta");

                                                } else if (dateTemp2 === "Invalid Date") {
                                                    alert("Fecha de agenda incorrecta");

                                                } else if (!intereses.some((interes) => interes.esp_id === idEspecialidad && interes.interest_status !== 3)) {
                                                    setIntereses((intereses) => [
                                                        ...intereses,
                                                        {
                                                            esp_id: idEspecialidad,
                                                            esp_nombre: nombreEspecialidad,
                                                            name: nombreStatusStudent,
                                                            interest_status: idStatusStudent,
                                                            age_nombre: "Diamond Central",
                                                            fecha_llamada: fechaLlamada,
                                                            fecha_agenda: fechaAgenda,
                                                            precio,
                                                        },]);
                                                }
                                                else {
                                                    alert('"' + nombreEspecialidad + '" ya se encuentra agregado.');
                                                }
                                            }}>
                                            Agregar interes
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>

            <div className="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true" >
                <div className="modal-dialog modal-dialog-centered modal-sm">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="staticBackdropLabel">Reagendar</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" ></button>
                        </div>
                        <div className="modal-body">
                            <label htmlFor="fechaAgenda">Nueva fecha</label>
                            <input type="date" className="form-control" id="fechaReAgenda"
                                onChange={(e) => {
                                    //setFechaAgenda(e.target.value);
                                }}/>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-primary" data-bs-dismiss="modal"
                                onClick={() => {
                                    intereses.find(
                                        (interes) =>
                                            interes.idEspecialidad == idEspecialidadReagendar
                                    ).fecha_agenda =
                                        document.getElementById("fechaReAgenda").value;
                                        setIntereses(JSON.parse(JSON.stringify(intereses)));
                                        document.getElementById("fechaReAgenda").value = "";
                                }} >
                                Reagendar
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal fade" id="addOrEditInterestModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true" >
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="staticBackdropLabel"> Editar: {specialityToEdit.esp_nombre} </h5>
                            <h4></h4>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" ></button>
                        </div>
                        <div className="modal-body">
                            <label htmlFor="callstatusEdited">Estatus</label>
                            <div className="form-group">
                                
                                {statusStudentList.length > 0 ? (
                                    <select {...register("callstatusEdited")} disabled={disabled} id="callstatusEdited" className="form-select" 
                                        onChange={(e) => { 
                                            specialityToEdit.nombreStatusStudent = e.target.options[e.target.selectedIndex].text;
                                            specialityToEdit.idStatusStudent = e.target.value;
                                        }}> 
                                        <option key='0' value='0' ></option>
                                        {statusStudentList.map((statusStudent, index) => (
                                            <option 
                                                selected = { specialityToEdit && statusStudent.id === specialityToEdit.interest_status}  
                                                key={statusStudent.id} value={statusStudent.id} >
                                                {statusStudent.name}
                                            </option>
                                        ))}
                                    </select>
                                ) : (
                                    <select className="form-select">
                                        <option>No disponible</option>
                                    </select>
                                )}
                            </div>
                                    
                            <label htmlFor="callDate">Fecha llamada</label>
                            <input type="date" className="form-control" id="callDateEdited"
                                defaultValue={
                                    specialityToEdit.fecha_llamada &&
                                    specialityToEdit.fecha_llamada.substring(0, 10)
                                }
                            />
                            <label className="mt-3" htmlFor="price">Precio</label>
                            <input type="number" className="form-control" id="priceEdited" defaultValue={specialityToEdit.precio}
                                onChange={(e) => {
                                    specialityToEdit.precio = Number(e.target.value);
                                }}
                            />
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-primary" data-bs-dismiss="modal" 
                                onClick={() => {
                                    specialityToEdit.interest_status = document.getElementById("callstatusEdited").value;
                                    specialityToEdit.name = document.getElementById("callstatusEdited").options[document.getElementById("callstatusEdited").selectedIndex].text;
                                    specialityToEdit.fecha_llamada = document.getElementById("callDateEdited").value;
                                    specialityToEdit.precio = Number(document.getElementById("priceEdited").value );
                                    setIntereses(JSON.parse(JSON.stringify(intereses)));

                                }}>
                                Guardar
                            </button>
                        </div>
                        

                    </div>
                </div>
            </div>

            <div className="modal fade" id="enrollModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true" >
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="staticBackdropLabel"> Inscribir </h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" ></button>
                        </div>
                        <div className="modal-body"><h4>{specialityToEnroll.esp_nombre}</h4>
                            <label className="mt-3" htmlFor="agencySpecialityToEnroll"> Agencia de inscripción</label>
                            <div className="form-group">
                                {agencies.length > 0 ? (
                                    <select {...register("agencia")} disabled={disabled} id="agencia" className="form-select">
                                        {agencies.map((agency, index) => {
                                            if (agency.age_status === "1") {
                                                return (
                                                    <option selected={ specialityToEnroll && agency.age_id === specialityToEnroll.age_id } key={agency.age_id} defaultValue={agency.age_id}>
                                                        {agency.age_nombre}
                                                    </option>
                                                );
                                            }
                                        })}
                                    </select>
                                ) : (
                                    <select className="form-select">
                                        <option>No disponible</option>
                                    </select>
                                )}
                            </div>
                            <label className="mt-3" htmlFor="fechaAgenda">
                                Fecha inscripción
                            </label>
                            <input type="date" className="form-control" id="fechaReAgenda"
                                onChange={(e) => {
                                    //setFechaAgenda(e.target.value);
                                }}
                            />
                            <label className="mt-3" htmlFor="fechaAgenda">
                                Precio final($)
                            </label>
                            <input type="number" className="form-control" id="finalPrice" 
                                onChange={(e) => {
                                    specialityToEnroll.finalPrice = e.target.value;
                                    //setFechaAgenda(e.target.value);
                                }}
                            />
                            <label className="mt-3" htmlFor="fechaAgenda">
                                Comisión($)
                            </label>
                            <input type="number" className="form-control" id="finalPrice" 
                                onChange={(e) => {
                                    specialityToEnroll.finalPrice = e.target.value;
                                    //setFechaAgenda(e.target.value);
                                }}
                            />
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-primary" data-bs-dismiss="modal"
                                onClick={() => {
                                    console.log(specialityToEnroll);
                                    // intereses.find(
                                    //   (interes) => interes.esp_id == idEspecialidadReagendar
                                    // ).fecha_agenda =
                                    //   document.getElementById("fechaReAgenda").value;
                                    // console.log(JSON.stringify(intereses));
                                    // setIntereses(JSON.parse(JSON.stringify(intereses)));
                                    // document.getElementById("fechaReAgenda").value = "";
                                }}
                            >
                                Reagendar
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Intereses;
